import {Button, Form, Mentions, Select, Switch} from 'antd'
import React, {useCallback, useMemo} from 'react'
import {getFiles} from '../../../../services/assistant'
import {InputSearch} from '../../../input-search'
import {EnterOutlined, UploadOutlined} from "@ant-design/icons";
import PublicFile from "../../../public-file";

export default function SendAudio({fieldName}) {
  return (
    <>
      <Form.Item
        label="Audios"
        name={[fieldName, 'action', 'data', 'audios']}
        rules={[{
          required: true,
          message: "É obrigatório adicionar pelo menos um audio",
        }]}
      >
        <PublicFile multiple>
          <Button icon={<UploadOutlined/>}>Subir Arquivo</Button>
        </PublicFile>
      </Form.Item>
    </>
  )
}
